// Texts go out from the phone's own messaging app, so they come from the
// business cell number the customer already knows (no SMS provider needed).
// `?&body=` is the spelling both iPhone and Android Messages accept.
export const smsHref = (phone, body) => {
  const to = String(phone || '').replace(/[^\d+]/g, '');
  if (!to) return undefined;
  return body ? `sms:${to}?&body=${encodeURIComponent(body)}` : `sms:${to}`;
};

export const onMyWayText = (techName, company = 'Xpert Pests Solutions') => {
  const first = String(techName || '').trim().split(/\s+/)[0];
  return `Hi, this is ${first ? `${first} from ` : ''}${company}. I'm on my way for your pest control service and should be there shortly.`;
};
